
<template>
    <div class="row-fluid">
        <div class="span16  wide-top-menu">
            <div class="row-fluid">
                <div class="span9  topmenu">
                    <div class="wrap-dropdown-multicolumns">
                        <ul class="dropdown-multicolumns clearfix">
                            <li class=" top-level">
                                <a class="drop" @click="redirectTopGroup(1, 'پمپ آب')" id="1" title="پمپ آب">
                                    پمپ آب
                                    <!--<i class="fa fa-align-left" title="پمپ آب"></i>-->
                                </a>
                                <div class="dropdown-column-item dropdown-5columns drop-left">
                                    <div class="menu-box">
                                        <div v-for="(menu, index) in navbarmenu" v-if="allowedIds(1).includes(menu.id)" :key="index" :class="{'col-1': true, 'col-md-6': true ,'div--group':true, 'firstcolumn': index === 0}">
                                            <router-link class="nav-link" :to="{ name: 'filter' , query: {  GroupId: menu.id ,  GroupName: menu.title.replace(/\s+/g, '-') }}" :title="menu.title">{{menu.title}}</router-link>
                                            <div class="div--submenu">
                                                <a style="display:none"></a>
                                                <router-link v-for="item in menu.items " v-if="item.type == 'SubGroup'" :title="item.title" :to="{ name: 'filter' , query: { SubGroupId: item.id , SubGroupName: item.title.replace(/\s+/g, '-') }}" class="subgroupsClass"> <i class="fa fa-circle dot-dd"></i> {{item.title}}</router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="top-level">
                                <a class="drop" @click="redirectTopGroup(2, 'تجهیزات کشاورزی و باغبانی')" id="2" title="تجهیزات کشاورزی و باغبانی">
                                    تجهیزات کشاورزی و باغبانی
                                    <!--<i class="fa fa-align-left"></i>-->
                                </a>
                                <div class="dropdown-column-item dropdown-5columns drop-left">
                                    <div class="menu-box">
                                        <div v-for="(menu, index) in navbarmenu"  v-if="allowedIds(2).includes(menu.id)"  :key="index" :class="{'col-1': true, 'col-md-3': true ,'div--group':true, 'firstcolumn': index === 0}">
                                            <router-link class="nav-link" :to="{ name: 'filter' , query: {  GroupId: menu.id ,  GroupName: menu.title.replace(/\s+/g, '-') }}" :title="menu.title">{{menu.title}}</router-link>
                                            <div class="div--submenu">
                                                <a style="display:none"></a>
                                                <router-link v-for="item in menu.items " v-if="item.type == 'SubGroup'" :title="item.title" :to="{ name: 'filter' , query: { SubGroupId: item.id , SubGroupName: item.title.replace(/\s+/g, '-') }}" class="subgroupsClass"> <i class="fa fa-circle dot-dd"></i> {{item.title}}</router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="top-level">
                                <a class="drop" @click="redirectTopGroup(3, 'الکترو موتور')" id="3" title="الکترو موتور">
                                    الکترو موتور
                                    <!--<i class="fa fa-align-left"></i>-->
                                </a>
                                <div class="dropdown-column-item dropdown-5columns drop-left">
                                    <div class="menu-box">
                                        <div v-for="(menu, index) in navbarmenu" v-if="allowedIds(3).includes(menu.id)"  :key="index" :class="{'col-1': true, 'col-md-3': true,'div--group':true, 'firstcolumn': index === 0}">
                                            <router-link class="nav-link" :to="{ name: 'filter' , query: {  GroupId: menu.id ,  GroupName: menu.title.replace(/\s+/g, '-') }}" :title="menu.title">{{menu.title}}</router-link>
                                            <div class="div--submenu">
                                                <a style="display:none"></a>
                                                <router-link v-for="item in menu.items " v-if="item.type == 'SubGroup'" :title="item.title" :to="{ name: 'filter' , query: { SubGroupId: item.id , SubGroupName: item.title.replace(/\s+/g, '-') }}" class="subgroupsClass"> <i class="fa fa-circle dot-dd"></i> {{item.title}}</router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class=" top-level">
                                <a class="drop" @click="redirectTopGroup(4, 'موتور ژنراتور')" id="4" title="موتور ژنراتور">
                                    موتور ژنراتور
                                    <!--<i class="fa fa-align-left " title="موتور ژنراتور"></i>-->
                                </a>
                                <div class="dropdown-column-item dropdown-5columns drop-left">
                                    <div class="menu-box">
                                        <div v-for="(menu, index) in navbarmenu" v-if="allowedIds(4).includes(menu.id)"  :key="index" :class="{'col-1': true, 'col-md-3': true,'div--group':true, 'firstcolumn': index === 0}">
                                            <router-link class="nav-link" :to="{ name: 'filter' , query: {  GroupId: menu.id ,  GroupName: menu.title.replace(/\s+/g, '-') }}" :title="menu.title">{{menu.title}}</router-link>
                                            <div class="div--submenu">
                                                <a style="display:none"></a>
                                                <router-link v-for="item in menu.items " v-if="item.type == 'SubGroup'" :title="item.title" :to="{ name: 'filter' , query: { SubGroupId: item.id , SubGroupName: item.title.replace(/\s+/g, '-') }}" class="subgroupsClass"> <i class="fa fa-circle dot-dd"></i> {{item.title}}</router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class=" top-level">
                                <a class="drop" @click="redirectTopGroup(5, 'ژنراتور')" id="5" title="ژنراتور">
                                    ژنراتور
                                    <!--<i class="fa fa-align-left"></i>-->
                                </a>
                                <div class="dropdown-column-item dropdown-5columns drop-left">
                                    <div class="menu-box">
                                        <div v-for="(menu, index) in navbarmenu" v-if="allowedIds(5).includes(menu.id)"   :key="index" :class="{'col-1': true, 'col-md-3': true,'div--group':true, 'firstcolumn': index === 0}">
                                            <router-link class="nav-link" :to="{ name: 'filter' , query: {  GroupId: menu.id ,  GroupName: menu.title.replace(/\s+/g, '-') }}" :title="menu.title">{{menu.title}}</router-link>
                                            <div class="div--submenu">
                                                <a style="display:none"></a>
                                                <router-link v-for="item in menu.items " v-if="item.type == 'SubGroup'" :title="item.title" :to="{ name: 'filter' , query: { SubGroupId: item.id , SubGroupName: item.title.replace(/\s+/g, '-') }}" class="subgroupsClass"> <i class="fa fa-circle dot-dd"></i> {{item.title}}</router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="top-level">
                                <a class="drop"  @click="redirectTopGroup(6, 'موتور دیزل')"  id="6" title="موتور دیزل ">
                                    موتور دیزل
                                    <!--<i class="fa fa-align-left"  title="موتور دیزل"></i>-->
                                </a>
                                <div class="dropdown-column-item dropdown-5columns drop-left">
                                    <div class="menu-box">
                                        <div v-for="(menu, index) in navbarmenu" v-if="allowedIds(6).includes(menu.id)"   :key="index" :class="{'col-1': true, 'col-md-3': true,'div--group':true, 'firstcolumn': index === 0}">
                                            <router-link class="nav-link" :to="{ name: 'filter' , query: {  GroupId: menu.id ,  GroupName: menu.title.replace(/\s+/g, '-') }}" :title="menu.title">{{menu.title}}</router-link>
                                            <div class="div--submenu">
                                                <a style="display:none"></a>
                                                <router-link v-for="item in menu.items " v-if="item.type == 'SubGroup'" :title="item.title" :to="{ name: 'filter' , query: { SubGroupId: item.id , SubGroupName: item.title.replace(/\s+/g, '-') }}" class="subgroupsClass"> <i class="fa fa-circle dot-dd"></i> {{item.title}}</router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class=" top-level">
                                <a class="drop" @click="redirectTopGroup(7, 'قطعات یدکی ')"  id="7" title="قطعات یدکی ">
                                    قطعات یدکی
                                    <!--<i class="fa fa-align-left"></i>-->
                                </a>
                                <div class="dropdown-column-item dropdown-5columns drop-left">
                                    <div class="menu-box">
                                        <div v-for="(menu, index) in navbarmenu" v-if="allowedIds(7).includes(menu.id)"   :key="index" :class="{'col-1': true, 'col-md-3': true,'div--group':true, 'firstcolumn': index === 0}">
                                            <router-link class="nav-link" :to="{ name: 'filter' , query: {  GroupId: menu.id ,  GroupName: menu.title.replace(/\s+/g, '-') }}" :title="menu.title">{{menu.title}}</router-link>
                                            <div class="div--submenu">
                                                <a style="display:none"></a>
                                                <router-link v-for="item in menu.items " v-if="item.type == 'SubGroup'" :title="item.title" :to="{ name: 'filter' , query: { SubGroupId: item.id , SubGroupName: item.title.replace(/\s+/g, '-') }}" class="subgroupsClass"> <i class="fa fa-circle dot-dd"></i> {{item.title}}</router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li v-if="baseInfo.IsShopBlog != null && baseInfo.ShopBlogName != null" class="top-level">
                                <a class="drop-store" target="_blank" :href="baseInfo.ShopBlogName">بلاگ</a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                isMenuOpen: false
            };
        },
        computed: {
            
            navbarmenu: function () {
                return this.$store.getters.readNavbarmenu;
            },
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        methods: {
            allowedIds(topGroupId) {
                const topGroup = this.$store.getters.readTopGroups.find(
                    (x) => x.Id == topGroupId
                );
                return  topGroup.GroupIds != null ?  topGroup.GroupIds.split(',').map(Number) : [];
            },
            redirectTopGroup(id, title) {
                this.$router.push({
                    path: '/filter',
                    query: { TopGroupId: id, TopGroupName: title },
                });
            },
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
            toggleMenu() {
                this.isMenuOpen = !this.isMenuOpen;
            },
            openMenu() {
                this.isMenuOpen = true;
            },
            closeMenu() {
                this.isMenuOpen = false;
            }
        }
    }

    $(function () {
        //$('body').on('click', '.redirect-topGroup', function () {
        //    var id = $(this).attr('id');
        //    var title = $(this).attr('title');
        //    window.open('/filter?TopGroupId=' + id + '&TopGroupName=' + title, '_Blank');

        //});
    });
</script>

<style scoped>
    .dot-dd {
        font-size: 4px;
        vertical-align: middle;
        color: #8e1717;
    }

    .topmenu .wrap-dropdown-multicolumns ul.dropdown-multicolumns li a.drop-store {
        font-size: 15px;
        line-height: 33px;
        color: #333;
        text-shadow: 1px 0px 1px #fff;
        font-weight: bold;
        border-bottom: 1px solid transparent;
    }

    .drop:hover {
        cursor: pointer;
    }

    .row-fluid::before, .row-fluid::after {
        display: table;
        content: "";
        line-height: 0;
    }

    .row-fluid::before, .row-fluid::after {
        display: table;
        content: "";
        line-height: 0;
    }

    .row-fluid [class*="span"]:first-child {
        margin-right: 0;
    }

    .row-fluid .span16 {
        width: 100%;
        *width: 99.94708994709%;
    }

    .row-fluid [class*="span"] {
        display: block;
        width: 100%;
        min-height: 0;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        float: right;
        margin-right: 1.5873015873016%;
    }

    .wide-top-menu {
        border-top: 1px solid #f3f3f3;
        margin: -2px 0 -1px;
        margin-right: 0px;
    }

    .row-fluid::before, .row-fluid::after {
        display: table;
        content: "";
        line-height: 0;
    }

    .row-fluid [class*="span"] {
        display: block;
        width: 100%;
        min-height: 0;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        float: right;
        margin-right: 1.5873015873016%;
        *margin-right: 1.5343915343915%;
    }

    .topmenu .wrap-dropdown-multicolumns {
        display: block;
        position: static;
        margin: 0 auto;
        width: 100%;
        min-width: 560px;
        height: auto;
        z-index: 100;
    }

    .clearfix::after {
        clear: both;
    }

    .clearfix::before, .clearfix::after {
        display: table;
        content: "";
        line-height: 0;
    }

    .topmenu .wrap-dropdown-multicolumns .dropdown-multicolumns {
        background-color: transparent;
        box-shadow: none;
    }


    ul.dropdown-multicolumns {
        border-color: #333;
    }

    .clearfix::before, .clearfix::after {
        display: table;
        content: "";
        line-height: 0;
    }

    .topmenu .wrap-dropdown-multicolumns ul.dropdown-multicolumns li {
        position: static;
        margin: 0;
        float: right;
        border: none;
        text-align: center;
        padding: 0;
    }

    .topmenu .wrap-dropdown-multicolumns .dropdown-multicolumns .top-level {
        transition: all 0.5s ease-in-out 0s;
    }

    .topmenu .wrap-dropdown-multicolumns ul.dropdown-multicolumns li a.drop, .topmenu .wrap-dropdown-multicolumns ul.dropdown-multicolumns li.nodrop a {
        font-size: 15px;
        line-height: 33px;
        color: #333;
        text-shadow: 1px 0px 1px #fff;
        font-weight: bold;
        border-bottom: 1px solid transparent;
    }

    .topmenu .wrap-dropdown-multicolumns ul.dropdown-multicolumns li a {
        padding: 9px 13px 7px 13px;
        text-decoration: none !important;
        font-size: 120%;
        font-weight: bold;
        text-shadow: none;
    }

    ul.dropdown-multicolumns li a.drop, ul.dropdown-multicolumns li.nodrop a {
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        text-decoration: none;
    }

    .topmenu .wrap-dropdown-multicolumns .dropdown-fullwidth, .topmenu .wrap-dropdown-multicolumns .dropdown-5columns, .topmenu .wrap-dropdown-multicolumns .dropdown-4columns, .topmenu .wrap-dropdown-multicolumns .dropdown-3columns, .topmenu .wrap-dropdown-multicolumns .dropdown-2columns {
        width: 100%;
        transition-delay: .5s;
    }

    .dropdown-1column, .dropdown-2columns, .dropdown-3columns, .dropdown-4columns, .dropdown-5columns, .dropdown-fullwidth, ul.dropdown-multicolumns {
        border-color: #4d4d4d;
    }

    .dropdown-1column, .dropdown-2columns, .dropdown-3columns, .dropdown-4columns, .dropdown-5columns, .dropdown-fullwidth {
        position: absolute;
        z-index: 999999;
        right: -999em;
        margin: 0px auto;
        padding: 20px 0 0;
        border: 0px solid #444;
        border-top-color: rgb(68, 68, 68);
        border-right-color: rgb(68, 68, 68);
        border-bottom-color: rgb(68, 68, 68);
        border-left-color: rgb(68, 68, 68);
        background-color: #fff;
        box-shadow: 0 5px 10px rgba(0,0,0,0.2);
        text-align: right;
    }

    div, p, .tabs ul li.active a, .tabs ul li.active a:visited, .tabs ul li.active a:hover, .tabs ul li.active a:active, .checkout-sidebox-title, .demo-site-panel select {
        color: #333;
    }

    .topmenu .wrap-dropdown-multicolumns li .menu-box {
        width: 1100px;
        margin: 0 auto;
    }

    .dropdown-multicolumns .firstcolumn {
        clear: right;
        margin-right: 9px;
    }

    .dropdown-multicolumns .col-1 {
        width: 145px;
    }

    .dropdown-multicolumns .col-1, .dropdown-multicolumns .col-2, .dropdown-multicolumns .col-3, .dropdown-multicolumns .col-4, .dropdown-multicolumns .col-5, .dropdown-multicolumns .col-6 {
        float: right;
        display: inline-block;
        margin-right: 10px;
        padding-bottom: 10px;
    }

    dropdown-multicolumns ul.dropdown-multicolumns li .col-1 a:first-child {
        background-color: transparent;
        padding: 0;
        border-bottom: 2px solid #ccc;
        display: block;
        color: #06d;
        line-height: 2em;
        font-weight: bold;
        font-size: 120%;
    }

    .topmenu .wrap-dropdown-multicolumns ul.dropdown-multicolumns li .dropdown-fullwidth .col-1 a,
    .topmenu .wrap-dropdown-multicolumns ul.dropdown-multicolumns li .col-1 a {
        font: 300 110%/1.7 iransans, tahoma;
        font-weight: 500;
        font-size: 110%;
        line-height: 1.7;
        background-color: transparent;
        padding: 0;
        display: inline-block;
        color: #444;
        position: relative;
        float: right;
        margin: 3px 0 5px;
        width: 135px;
        text-align: right;
        text-shadow: 1px 1px 1px #fff;
        line-height: 125%;
    }

    .topmenu .wrap-dropdown-multicolumns ul.dropdown-multicolumns li a {
        padding: 9px 13px 7px 13px;
        text-decoration: none !important;
        font-size: 120%;
        font-weight: bold;
        text-shadow: none;
    }

    .topmenu .wrap-dropdown-multicolumns ul.dropdown-multicolumns > li.active {
        background-color: #f3f3f3;
    }

    .topmenu .wrap-dropdown-multicolumns .dropdown-multicolumns .top-level {
        transition: all 0.5s ease-in-out 0s;
    }

    .topmenu .wrap-dropdown-multicolumns .dropdown-multicolumns li:hover .drop-left {
        top: auto;
    }

    .dropdown-multicolumns li:hover .drop-left {
        top: 25px;
        right: -1px;
        left: auto;
    }

    multicolumns li:hover .dropdown-2columns, .dropdown-multicolumns li:hover .dropdown-3columns, .dropdown-multicolumns li:hover .dropdown-4columns, .dropdown-multicolumns li:hover .dropdown-5columns {
        right: 0px;
        display: block;
        left: auto;
    }

    .topmenu .wrap-dropdown-multicolumns ul.dropdown-multicolumns > li.active {
        background-color: #f3f3f3;
    }

    .topmenu .wrap-dropdown-multicolumns .dropdown-multicolumns .top-level {
        transition: all 0.5s ease-in-out 0s;
    }

    .topmenu .wrap-dropdown-multicolumns ul.dropdown-multicolumns li {
        position: static;
        margin: 0;
        float: right;
        border: none;
        text-align: center;
    }

        .topmenu .wrap-dropdown-multicolumns ul.dropdown-multicolumns li .col-1 a:first-child {
            background-color: transparent;
            padding: 0;
            border-bottom: 2px solid #ccc;
            display: block;
            color: #8e1717;
            line-height: 2em;
            font-weight: bold;
            font-size: 14px;
            height: 70px;
        }

        .topmenu .wrap-dropdown-multicolumns ul.dropdown-multicolumns li .col-1 a {
            font: 300 110%/1.7 iranyekan;
            font-weight: 300;
            font-size: 100%;
            line-height: 1.7;
            background-color: transparent;
            padding: 0;
            display: inline-block;
            color: #444;
            position: relative;
            float: right;
            margin: 3px 0 5px;
            width: 135px;
            /*           height:80px;*/
            text-align: right;
            text-shadow: 1px 1px 1px #fff;
        }

    .wrap-dropdown-multicolumns {
        margin-top: 10px !important;
        padding-right: 20px;
    }

    .dropdown-multicolumns {
        margin-bottom: 0 !important;
    }

    .subgroupsClass:hover {
        transition: all .3s;
        font-weight: bold !important;
        color: #8e1717 !important;
    }

    .div--group {
        position: relative; /* برای موقعیت‌دهی زیرمنو */
    }

    .div--submenu {
        display: none; /* زیرمنو به‌طور پیش‌فرض مخفی است */
        position: absolute; /* برای نمایش زیر منوی شناور */
        top: 86%;
        right: 3px;
        background-color: white;
        border: 1px solid #ddd;
        z-index: 1000;
        padding: 10px;
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    }

    .div--group:hover .div--submenu {
        display: block; /* نمایش زیرمنو در حالت هاور روی گروه */
    }
</style>